import { tt } from "../../../utils/i18n/i18n";
import React from "react";
import KC_UIText from "../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../designsystem/ds_commons";
import { Form, Formik } from "formik";
import KC_Button, {
  KC_ButtonSize
} from "../../../designsystem/KC_Button/KC_Button";
import { setLoading } from "../../../redux/actions/app";
import {
  updateCustomerThunk,
  useAccountToDisplaySelector
} from "../../../redux/actions/user";
import { useDispatch } from "react-redux";
import KC_Input from "../../../designsystem/KC_FormInput/KC_Input";
import KC_PhoneInput from "../../../designsystem/KC_PhoneInput/KC_PhoneInput";
import ShippingAddressForm from "../../../components/ShippingAddressForm/ShippingAddressForm";
import BusinessUser from "@tootsweet/model/entities/BusinessUser";

interface Props {
  customer: BusinessUser | undefined;
}

export default function (props: Props) {
  const dispatch = useDispatch();
  const { accountToDisplay } = useAccountToDisplaySelector();

  const handleSubmit = (values: BusinessUser) => {
    try {
      dispatch(setLoading(true));
      dispatch(
        updateCustomerThunk(
          {
            shippingAddress: values.shippingAddress
          },
          props.customer?.trackingID,
          accountToDisplay?.token
        )
      );
    } catch (err) {
      console.error(err);
      alert(tt("error"));
    } finally {
      setTimeout(() => {
        dispatch(setLoading(false));
      }, 500);
    }
  };

  if (!props.customer) {
    return null;
  }

  return (
    <Formik<BusinessUser>
      key={props.customer.trackingID}
      initialValues={props.customer}
      onSubmit={handleSubmit}
      enableReinitialize={true}
    >
      {({ values, setFieldValue, dirty }) => {
        return (
          <Form id="shippingAddress-form" className="h-100" autoComplete="off">
            <div className="w-100 d-flex flex-column st-gap h-100">
              <ShippingAddressForm
                address={values.shippingAddress}
                setFieldValue={setFieldValue}
                fieldPrefix="shippingAddress"
              />
              {values?.shippingAddress?.countryCode === "FR" && (
                <>
                  <div>
                    <label htmlFor="shippingAddress.name">
                      <KC_UIText
                        weight={KC_Weights.md}
                        text={tt("deliveryContactLabel")}
                      />
                    </label>
                    <KC_Input
                      id="shippingAddress-name"
                      htmlFor="shippingAddress.name"
                      placeholder={""}
                      type="text"
                      setFieldValue={setFieldValue}
                      required={true}
                      value={values?.shippingAddress?.name || ""}
                    />
                  </div>
                  <div>
                    <label htmlFor="shippingAddress.phoneNumber">
                      <KC_UIText
                        weight={KC_Weights.md}
                        text={tt("deliveryContactPhoneLabel")}
                      />
                    </label>
                    <KC_PhoneInput
                      id="shippingAddress-phoneNumber"
                      htmlFor="shippingAddress.phoneNumber"
                      placeholder={""}
                      setFieldValue={setFieldValue}
                      required={true}
                      value={values?.shippingAddress?.phoneNumber || ""}
                      defaultCountry={
                        (values?.shippingAddress?.countryCode?.toLowerCase() as any) ||
                        "fr"
                      }
                    />
                  </div>
                </>
              )}
              <div className="flex-grow-1" />
              <KC_Button
                id="save"
                type="submit"
                text={tt("save")}
                size={KC_ButtonSize.Large}
                className="d-flex"
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}
